import { cva } from 'class-variance-authority';

// Posição da alça: no peek em repouso ela vira a barra fixa no rodapé da
// viewport; no resto fica `relative` em fluxo. `static` é PROIBIDO: a alça
// precisa ser contexto de posicionamento para a área de toque
// (`data-touch-extension`, absolute) ficar ancorada nela — com `static` ela se
// mede pelo `.bottom-sheet` e estoura abaixo do footer (captura o scroll como
// drag e deixa o mapa vazar).
export const handlePosition = cva('', {
	variants: {
		state: {
			// Barra fixa no rodape da viewport. `pb`/`h` usam
			// `max(16px, env(safe-area-inset-bottom))`: em aparelhos onde o
			// `env()` resolve 0 (Home button / barra flutuante do Safari), o
			// recuo minimo de 16px impede que a barra do navegador cubra o CTA.
			// `!` (important) em TODO o posicionamento e proposital: a alca carrega
			// o global `.bottom-sheet__handle` (`z-index: 35`) e classes inline
			// (`relative`, `h-6`, `pt-[6px]`). Sem `!`, `fixed`/`relative` e
			// `z-50`/`z-35` se resolvem por ordem de bundle — e na transicao
			// CLOSED->half->peek (com a barra de URL do iOS oscilando) isso pode
			// cair pro lado errado e jogar o CTA pra fora da viewport.
			peek: "fixed! inset-x-0! bottom-0! z-50! bg-white! pt-0! pb-[max(16px,env(safe-area-inset-bottom))]! h-[calc(4rem_+_max(16px,env(safe-area-inset-bottom)))]! after:absolute after:inset-x-0 after:top-full after:h-20 after:bg-white after:content-['']",
			anchored: 'relative'
		}
	}
});

// Posição do CTA por estado.
export const ctaPosition = cva('', {
	variants: {
		state: {
			peek: 'absolute inset-x-0 top-0 h-16 z-10 opacity-100 pointer-events-auto',
			hidden: 'absolute inset-x-0 top-0 z-30 opacity-0 pointer-events-none'
		}
	}
});
